import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { collectionListQueryOptions } from '@/hooks/collections/use-collections';
import type { RespondedType, ResponseError } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export default function useDeleteCollection() {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, number>({
    mutationKey: ['/DeleteCollect'],
    mutationFn: (params) => fetcher('/DeleteCollect', { ID: params }, { validResponseCodes: [0, 1] }),
    onSuccess: (_, params) => {
      queryClient.setQueryData(collectionListQueryOptions.queryKey, (state) =>
        produce(state, (draft) => draft?.filter((collection) => collection.ID !== params)),
      );
    },
  });
}
